export default __webpack_public_path__ + "50b36bcbfc4752e533826f5892dddfff.svg";